import { render, staticRenderFns } from "./create-integration-link-form.vue?vue&type=template&id=4c3b894d&"
import script from "./create-integration-link-form.vue?vue&type=script&lang=js&"
export * from "./create-integration-link-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports